import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/web.timers.js";
import { defineComponent } from "vue";
import ImageCarousel from './ImageCarousel.vue';
export default defineComponent({
  name: "NewAvatarSelector",
  components: {
    ImageCarousel: ImageCarousel
  },
  setup: function setup() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.$store.dispatch('crazyEggStartRecording');
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  watch: {
    "$store.state.permission_location": "handleLocationPermissionsChange"
    // "$store.state.queuedCloudTTSSentences": "processCloudTTSPayloads",
  },
  props: {},
  data: function data() {
    return {
      rating: 0,
      deniedPermissions: false,
      permissionGranted: false,
      showReviewButton: false,
      feedback: "",
      dualSubmission: false,
      handleLowerScores: false,
      shareFeedbackText: "Share Feedback With Us",
      lowerScoreSentence: "",
      success: false,
      avatars: [{
        image: 'assets/web/avatarSelector/mary.webp',
        header: 'Mary',
        avatar: 'mary',
        description: '',
        nextButtonLabel: 'Next',
        imageStyles: {
          height: "55vh",
          width: "auto",
          "max-height": "80%",
          "object-fit": "cover"
        }
      }, {
        image: 'assets/web/avatarSelector/marcus.webp',
        header: 'Marcus',
        avatar: 'marcus',
        nextButtonLabel: 'Next',
        description: '',
        imageStyles: {
          height: "55vh",
          width: "auto",
          "max-height": "80%",
          "object-fit": "cover"
        }
      }, {
        image: 'assets/web/avatarSelector/sarah.webp',
        header: 'Sarah',
        avatar: 'sarah',
        nextButtonLabel: 'Next',
        description: '',
        imageStyles: {
          height: "55vh",
          width: "auto",
          "max-height": "80%",
          "object-fit": "cover"
        }
      }, {
        image: 'assets/web/avatarSelector/kurt.webp',
        header: 'kurt',
        avatar: 'kurt',
        hideNextButton: true,
        description: '',
        imageStyles: {
          height: "55vh",
          width: "auto",
          "max-height": "80%",
          "object-fit": "cover"
        }
      }]
      // data
    };
  },
  methods: {
    selectAvatar: function selectAvatar() {
      // this.$store.dispatch('crazyEggStopRecording');
      console.log('oh you would like to select', this.avatars[this.$store.state.newAvatarSelector].avatar);
      this.$store.commit('updateAvatar', this.avatars[this.$store.state.newAvatarSelector].avatar);
      this.$store.commit('updateProfileCompleted', true);
      this.$store.commit("updateShowAvatarSettings", false);
      this.$store.commit("updateShowMainMenu", false);
      this.$store.commit('updateShowAvatarSelector', false);
    },
    handleLocationPermissionsChange: function handleLocationPermissionsChange() {
      if (this.$store.state.permission_location === true || this.$store.state.permission_location === "true") {
        this.permissionGranted = true;
      } else if (this.$store.state.permission_location === "denied") {
        this.permissionGranted = false;
      } else {
        this.permissionGranted = false;
      }
    },
    closeModal: function closeModal() {
      this.$store.commit('updateShowAvatarSelector', false);
    },
    handleRating: function handleRating(n) {
      var _this2 = this;
      this.rating = n;
      setTimeout(function () {
        if (n > 4) {
          if (_this2.handleLowerScores) {
            _this2.lowerScoreSentence = "Sweet! We love to hear that! Please leave a review on the app store!";
            _this2.shareFeedbackText = "Share Feedback";
            _this2.dualSubmission = true;
            _this2.showReviewButton = false;
          } else {
            _this2.showReviewButton = true;
          }
        } else {
          _this2.showReviewButton = false;
        }
        if (n <= 4) {
          _this2.handleLowerScores = true;
          if (n <= 2) {
            _this2.lowerScoreSentence = "Bummer! What can we do to fix this?!";
          }
          if (n > 2 && n < 4) {
            _this2.lowerScoreSentence = "Not a perfect score. We can do better! What should we work on?";
          }
          if (n === 4) {
            _this2.lowerScoreSentence = "Dang! Almost five stars! What do we need to improve to get your five stars?";
          }
        }
      }, 1100);
    }
  }
});